export const NOTIFICATIONS = "NOTIFICATIONS";
export const NOTIFICATION_COUNT = "NOTIFICATION_COUNT";
